/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Equipment,
  EquipmentAttachmentsList,
  EquipmentList,
  EquipmentParams,
  Equipments,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Equipment list
 */
export const equipment = (
    params?: MaybeRefOrGetter<EquipmentParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Equipments>(
      {url: `/equipment`, method: 'GET',
        params, signal
    },
      );
    }




export const getEquipmentQueryKey = (params?: MaybeRefOrGetter<EquipmentParams>,) => {
    return [
    'equipment', ...(params ? [params] : [])
    ] as const;
    }


export const getEquipmentQueryOptions = <TData = Awaited<ReturnType<typeof equipment>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<EquipmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipment>>> = ({ signal }) => equipment(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipment>>, TError, TData>
}

export type EquipmentQueryResult = NonNullable<Awaited<ReturnType<typeof equipment>>>
export type EquipmentQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Equipment list
 */

export function useEquipment<TData = Awaited<ReturnType<typeof equipment>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<EquipmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment detail
 */
export const equipmentItem = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Equipment>(
      {url: `/equipment/${slug}`, method: 'GET', signal
    },
      );
    }




export const getEquipmentItemQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'equipment',slug
    ] as const;
    }


export const getEquipmentItemQueryOptions = <TData = Awaited<ReturnType<typeof equipmentItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentItemQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentItem>>> = ({ signal }) => equipmentItem(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentItem>>, TError, TData>
}

export type EquipmentItemQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentItem>>>
export type EquipmentItemQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Equipment detail
 */

export function useEquipmentItem<TData = Awaited<ReturnType<typeof equipmentItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItem>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentItemQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Attachments that fit an equipment item
 */
export const equipmentItemAttachments = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<EquipmentAttachmentsList>(
      {url: `/equipment/${slug}/attachments`, method: 'GET', signal
    },
      );
    }




export const getEquipmentItemAttachmentsQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'equipment',slug,'attachments'
    ] as const;
    }


export const getEquipmentItemAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof equipmentItemAttachments>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemAttachments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentItemAttachmentsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentItemAttachments>>> = ({ signal }) => equipmentItemAttachments(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentItemAttachments>>, TError, TData>
}

export type EquipmentItemAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentItemAttachments>>>
export type EquipmentItemAttachmentsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Attachments that fit an equipment item
 */

export function useEquipmentItemAttachments<TData = Awaited<ReturnType<typeof equipmentItemAttachments>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemAttachments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentItemAttachmentsQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Other versions of an equipment item
 */
export const equipmentItemVersions = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<EquipmentList>(
      {url: `/equipment/${slug}/versions`, method: 'GET', signal
    },
      );
    }




export const getEquipmentItemVersionsQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'equipment',slug,'versions'
    ] as const;
    }


export const getEquipmentItemVersionsQueryOptions = <TData = Awaited<ReturnType<typeof equipmentItemVersions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemVersions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentItemVersionsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentItemVersions>>> = ({ signal }) => equipmentItemVersions(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentItemVersions>>, TError, TData>
}

export type EquipmentItemVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentItemVersions>>>
export type EquipmentItemVersionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Other versions of an equipment item
 */

export function useEquipmentItemVersions<TData = Awaited<ReturnType<typeof equipmentItemVersions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemVersions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentItemVersionsQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Weapons an attachment fits
 */
export const equipmentItemWeapons = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<EquipmentList>(
      {url: `/equipment/${slug}/weapons`, method: 'GET', signal
    },
      );
    }




export const getEquipmentItemWeaponsQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'equipment',slug,'weapons'
    ] as const;
    }


export const getEquipmentItemWeaponsQueryOptions = <TData = Awaited<ReturnType<typeof equipmentItemWeapons>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemWeapons>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentItemWeaponsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentItemWeapons>>> = ({ signal }) => equipmentItemWeapons(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentItemWeapons>>, TError, TData>
}

export type EquipmentItemWeaponsQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentItemWeapons>>>
export type EquipmentItemWeaponsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Weapons an attachment fits
 */

export function useEquipmentItemWeapons<TData = Awaited<ReturnType<typeof equipmentItemWeapons>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemWeapons>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentItemWeaponsQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






